const alldealboughtdata = { data: [], loading: true };


export const GetAllDealBoughtRed = (state = alldealboughtdata, action) => {
    switch (action.type) {

        case "get_dealboughtdata":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }

}